<template>
  <v-container class="d-flex flex-column ga-3">
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code" :tabs="tabs">
          <div class="wrapper">
            <v-container>
              <div class="grid-container">
                <div class="section-title">Examples</div>
                <div class="section-title">Compact</div>
                <div class="section-title">Regular</div>

                <div>Menu from Avatar</div>
                <div>
                  <HxMenu
                    id="menu-from-avatar-compact"
                    v-slot="props"
                    :items="menuItems"
                    compact
                    @click="menuClick"
                  >
                    <v-avatar v-bind="props" color="primary">A</v-avatar>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-from-avatar-regular"
                    v-slot="props"
                    :items="menuItems"
                    @click="menuClick"
                  >
                    <v-avatar v-bind="props" color="primary">A</v-avatar>
                  </HxMenu>
                </div>

                <div>Menu from Button</div>
                <div>
                  <HxMenu
                    id="menu-from-button-compact"
                    v-slot="props"
                    :items="menuItems"
                    compact
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-from-button-regular"
                    v-slot="props"
                    :items="menuItems"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu from Searchbar</div>
                <div style="background-color: white; border-radius: 4px; max-width: 258px">
                  <HxMenu
                    id="menu-from-searchbar-compact"
                    v-slot="props"
                    :items="menuItems"
                    compact
                    @click="menuClick"
                  >
                    <HxSearch
                      v-bind="props"
                      search=""
                      placeholder="Search"
                      min-width="150px"
                    ></HxSearch>
                  </HxMenu>
                </div>

                <div style="background-color: white; border-radius: 4px; max-width: 258px">
                  <HxMenu
                    id="menu-from-searchbar-regular"
                    v-slot="props"
                    :items="menuItems"
                    @click="menuClick"
                  >
                    <HxSearch
                      v-bind="props"
                      search=""
                      placeholder="Search"
                      min-width="150px"
                    ></HxSearch>
                  </HxMenu>
                </div>

                <div>Menu Items with Icon and Divider</div>
                <div>
                  <HxMenu
                    id="menu-items-with-icon-and-divider-compact"
                    v-slot="props"
                    :items="menuItemsIconDivider"
                    compact
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-items-with-icon-and-divider-regular"
                    v-slot="props"
                    :items="menuItemsIconDivider"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu Items with Long Title (default maxCharacters)</div>
                <div>
                  <HxMenu
                    id="menu-items-with-long-title-compact"
                    v-slot="props"
                    :items="menuItemsLongTitle"
                    compact
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-items-with-long-title-regular"
                    v-slot="props"
                    :items="menuItemsLongTitle"
                    tooltip-direction="left"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu Items with Long Title (specified maxCharacters)</div>
                <div>
                  <HxMenu
                    id="menu-items-with-long-title-compact-with-specified-max-characters"
                    v-slot="props"
                    :items="menuItemsLongTitle"
                    compact
                    :max-characters="24"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-items-with-long-title-regular-with-specified-max-characters"
                    v-slot="props"
                    :items="menuItemsLongTitle"
                    :max-characters="24"
                    tooltip-direction="left"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu with Scroll</div>
                <div>
                  <HxMenu
                    id="menu-with-scroll-compact"
                    v-slot="props"
                    :items="longMenuItems"
                    compact
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-with-scroll-regular"
                    v-slot="props"
                    :items="longMenuItems"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu with Items Indentation</div>
                <div>
                  <HxMenu
                    id="menu-with-items-indentation-compact"
                    v-slot="props"
                    :items="menuItemsIndentation"
                    compact
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-with-items-indentation-regular"
                    v-slot="props"
                    :items="menuItemsIndentation"
                    @click="menuClick"
                  >
                    <v-btn v-bind="props" color="primary">Menu</v-btn>
                  </HxMenu>
                </div>

                <div>Menu A from Button dots-vertical</div>
                <div>
                  <HxMenu
                    id="menu-a-from-button-dots-vertical-compact"
                    v-slot="props"
                    v-model:isToggled="isEnabled"
                    :items="menuDotsVerticalA"
                    compact
                    :max-characters="24"
                    @click="clickToPrintIconName"
                  >
                    <HxButton
                      ghost
                      :variant="'secondary'"
                      left-icon="mdi-dots-vertical"
                      v-bind="props"
                    />
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-a-from-button-dots-vertical-regular"
                    v-slot="props"
                    v-model:isToggled="isEnabled"
                    :items="menuDotsVerticalA"
                    :max-characters="24"
                    tooltip-direction="left"
                    @click="clickToPrintIconName"
                  >
                    <HxButton
                      ghost
                      :variant="'secondary'"
                      left-icon="mdi-dots-vertical"
                      v-bind="props"
                    />
                  </HxMenu>
                </div>

                <div>Menu B from Button dots-vertical</div>
                <div>
                  <HxMenu
                    id="menu-b-from-button-dots-vertical-compact"
                    v-slot="props"
                    v-model:isToggled="isEnabled"
                    :items="computedMenuItems"
                    compact
                    :max-characters="24"
                    @click="clickToPrintIconName"
                  >
                    <HxButton
                      ghost
                      :variant="'secondary'"
                      left-icon="mdi-dots-vertical"
                      v-bind="props"
                    />
                  </HxMenu>
                </div>

                <div>
                  <HxMenu
                    id="menu-b-from-button-dots-vertical-regular"
                    v-slot="props"
                    v-model:isToggled="isEnabled"
                    :items="computedMenuItems"
                    :max-characters="24"
                    tooltip-direction="left"
                    @click="clickToPrintIconName"
                  >
                    <HxButton
                      ghost
                      :variant="'secondary'"
                      left-icon="mdi-dots-vertical"
                      v-bind="props"
                    />
                  </HxMenu>
                </div>
              </div>
            </v-container>
          </div>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixMenus',
  components: { UsageExample },
  setup() {
    const code = `
// Data structure for items prop
const items = [
  {
    title: 'Example 1', // string  -  Menu item display text
    icon: 'mdi-home',   // string  -  MDI icon name (optional)
    hasDivider: true    // boolean -  Show divider below item (optional)
  },
  {
    title: 'Example 2',
    icon: 'mdi-account'
  },
  ....
  {
    title: 'Add child page',
    icon: 'mdi-plus-circle-outline',
    hasDivider: false
  },
  {
    title: 'Add to favorites',
    icon: 'mdi-bookmark',
    hasDivider: false
  },
  {
    title: 'Remove from favorites',
    icon: 'mdi-bookmark-outline',
    hasDivider: false
  },
  {
    title: 'Hide page',
    icon: '$i-view',
    hasDivider: false
  },
  {
    title: 'Show page',
    icon: 'mdi-eye-outline',
    hasDivider: false
  },
  {
    title: 'Lock page visibility',
    icon: 'mdi-lock-outline',
    hasDivider: false,
    showToggleSwitch: true
  },
  {
    title: 'Unlock page visibility',
    icon: 'mdi-lock-open-outline',
    hasDivider: false
  },
  {
    title: 'Move to...',
    icon: 'mdi-arrow-all',
    hasDivider: false
  },
  {
    title: 'Rename',
    icon: '$i-text-select',
    hasDivider: false
  },
  {
    title: 'View unpublished changes',
    icon: '$i-history',
    hasDivider: true
  },
  {
    title: 'Delete page',
    icon: '$i-trash',
    hasDivider: false,
    color: 'red'
  },
  {
    title: this.isEnabled ? 'Unlock page visibility' : 'Lock page visibility',
    icon: this.isEnabled ? 'mdi-lock-outline' : 'mdi-lock-open-outline',
    hasDivider: false,
    showToggleSwitch: true
  },
  {
    title: this.isEnabled ? 'Show page' : 'Hide page',
    icon: this.isEnabled ? 'mdi-eye-outline' : '$i-view',
    hasDivider: false,
    showToggleSwitch: true
  }
];

// Menu from Avatar
<HxMenu id="menu-from-avatar-compact" v-slot="props" :items="menuItems" compact @click="menuClick">
  <v-avatar v-bind="props" color="primary">A</v-avatar>
</HxMenu>

<HxMenu id="menu-from-avatar-regular" v-slot="props" :items="menuItems" @click="menuClick">
  <v-avatar v-bind="props" color="primary">A</v-avatar>
</HxMenu>

// Menu from Button
<HxMenu id="menu-from-button-compact" v-slot="props" :items="menuItems" compact @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu id="menu-from-button-regular" v-slot="props" :items="menuItems" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu from Searchbar
<HxMenu id="menu-from-searchbar-compact" v-slot="props" :items="menuItems" compact @click="menuClick">
  <HxSearch v-bind="props" placeholder="Search with Menu" clearable min-width="200px"></HxSearch>
</HxMenu>

<HxMenu id="menu-from-searchbar-regular" v-slot="props" :items="menuItems" @click="menuClick">
  <HxSearch v-bind="props" placeholder="Search with Menu" clearable min-width="200px"></HxSearch>
</HxMenu>

// Menu Items with Icon and Divider
<HxMenu id="menu-items-with-icon-and-divider-compact" v-slot="props" :items="menuItemsIconDivider" compact @click="menuClick">
    <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu id="menu-items-with-icon-and-divider-regular" v-slot="props" :items="menuItemsIconDivider" @click="menuClick">
    <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu Items with Long Title (default maxCharacters)
<HxMenu id="menu-items-with-long-title-compact" v-slot="props" :items="menuItemsLongTitle" compact @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu id="menu-items-with-long-title-regular" v-slot="props" :items="menuItemsLongTitle" tooltip-direction="left" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu Items with Long Title (specified maxCharacters)
<HxMenu id="menu-items-with-long-title-compact-with-specified-max-characters" v-slot="props" :items="menuItemsLongTitle" compact :max-characters="24" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu id="menu-items-with-long-title-regular-with-specified-max-characters" v-slot="props" :items="menuItemsLongTitle" :max-characters="24" tooltip-direction="left" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu with Scroll
<HxMenu id="menu-with-scroll-compact" v-slot="props" :items="longMenuItems" compact @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu id="menu-with-scroll-regular" v-slot="props" :items="longMenuItems" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu with Items Indentation
<HxMenu id="menu-with-items-indentation-compact" v-slot="props" :items="menuItemsIndentation" compact @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

<HxMenu id="menu-with-items-indentation-regular" v-slot="props" :items="menuItemsIndentation" @click="menuClick">
  <v-btn v-bind="props" color="primary">Menu</v-btn>
</HxMenu>

// Menu from Button dots-vertical
<HxMenu id="menu-from-button-dots-vertical-compact" v-slot="props" v-model:isToggled="isEnabled" :items="menuDotsVertical" compact :max-characters="24" @menu-item-click="menuClick">
  <HxButton ghost :variant="'secondary'" left-icon="mdi-dots-vertical" v-bind="props" />
</HxMenu>
    `;
    return {
      code
    };
  },
  data() {
    return {
      isEnabled: false,
      tab: 'Menu Usage',
      tabs: ['Menu Usage'],
      menuItems: [
        { title: 'Go to home' },
        { title: 'Click me 1' },
        { title: 'Click me 2' },
        { title: 'Click me 3' }
      ],
      menuItemsIconDivider: [
        { title: 'Go to home', icon: 'mdi-home', hasDivider: true },
        { title: 'Click me 1', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 2', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 3', icon: 'mdi-cog', hasDivider: false }
      ],
      menuItemsLongTitle: [
        { title: 'Go to home' },
        { title: 'Click me 1 with title longer than default maximum of 49 characters' },
        { title: 'Click me 2 with title longer than default maximum of 49 characters' },
        { title: 'Click me 3 with title longer than default maximum of 49 characters' }
      ],
      longMenuItems: [
        { title: 'Go to home', icon: 'mdi-home', hasDivider: true },
        { title: 'Click me 1', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 2', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 3', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 4', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 5', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 6', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 7', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 8', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 9', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 10', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 11', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 12', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 13', icon: 'mdi-cog', hasDivider: true },
        { title: 'Click me 14', icon: 'mdi-cog', hasDivider: false }
      ],
      menuItemsIndentation: [
        { title: 'Go to home' },
        { title: '    Click me 1' },
        { title: '    Click me 2' },
        { title: 'Go elsewhere' },
        { title: '    Click me 1' },
        { title: '    Click me 2' }
      ],
      menuDotsVerticalA: [
        {
          title: 'Add child page',
          icon: 'mdi-plus-circle-outline',
          hasDivider: false
        },
        {
          title: 'Add to favorites',
          icon: 'mdi-bookmark-outline',
          hasDivider: false
        },
        {
          title: 'Hide page',
          icon: '$i-view',
          hasDivider: false
        },
        {
          title: 'Lock page visibility',
          icon: 'mdi-lock-outline',
          hasDivider: false,
          showToggleSwitch: true
        },
        {
          title: 'Move to...',
          icon: 'mdi-arrow-all',
          hasDivider: false
        },
        {
          title: 'Rename',
          icon: '$i-text-select',
          hasDivider: false
        },
        {
          title: 'View unpublished changes',
          icon: '$i-history',
          hasDivider: true
        },
        {
          title: 'Delete page',
          icon: '$i-trash',
          hasDivider: false,
          color: 'red'
        }
      ]
    };
  },
  computed: {
    computedMenuItems() {
      return [
        {
          title: 'Add child page',
          icon: 'mdi-plus-circle-outline',
          hasDivider: false
        },
        {
          title: 'Remove from favorites',
          icon: 'mdi-bookmark',
          hasDivider: false
        },
        {
          title: this.isEnabled ? 'Show page' : 'Hide page',
          icon: this.isEnabled ? 'mdi-eye-outline' : '$i-view',
          hasDivider: false,
          showToggleSwitch: true
        },
        {
          title: this.isEnabled ? 'Unlock page visibility' : 'Lock page visibility',
          icon: this.isEnabled ? 'mdi-lock-outline' : 'mdi-lock-open-outline',
          hasDivider: false,
          showToggleSwitch: true
        },
        {
          title: 'Move to...',
          icon: 'mdi-arrow-all',
          hasDivider: false
        },
        {
          title: 'Rename',
          icon: '$i-text-select',
          hasDivider: false
        },
        {
          title: 'View unpublished changes',
          icon: '$i-history',
          hasDivider: true
        },
        {
          title: 'Delete page',
          icon: '$i-trash',
          hasDivider: false,
          color: 'red'
        }
      ];
    }
  },
  methods: {
    menuClick(_, index) {
      switch (index) {
        case 0:
          this.$router.push('/');
          break;
        default:
          console.log(`Action triggered for menu item ${index + 1}`);
      }
    },
    clickToPrintIconName(item, index) {
      if (!item) {
        console.error('No item found at index:', item);
        return;
      }
      console.log(`Clicked Item ${index + 1}, Title: '${item.title}', Icon: '${item.icon}'`);
    }
  }
};
</script>

<style scoped>
.wrapper {
  background-color: rgb(238, 238, 238);
}

.section-title {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 1rem;
  margin-top: 1rem;
  display: flex;
  align-items: center;
}

.grid-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px;
  padding: 10px;
  align-items: center;
}
</style>
